import StickerType from 'common/enums/stickersTypes';
import useFlexBoxStyles from 'common/flexBox';
import Poster from 'common/posters/Poster';
import Chyron from './components/chyron/Chyron';

const StickerItemPreview = (props) => {
    const { sticker } = props;

    const { classes: flexBox, cx } = useFlexBoxStyles();

    return (
        <>
            {sticker.stickerType === StickerType.CHYRON && (
                <div className={cx(flexBox.w100, flexBox.padding02)}>
                    <div className={cx(flexBox.borderRadius1, flexBox.overflowHidden)}>
                        <Chyron
                            snippets={sticker.text.replace(/\r/g, '').split(/\n/)}
                            color={sticker.color}
                            size="small"
                            speed={8000}
                            uppercase={true}
                        />
                    </div>
                </div>
            )}

            {sticker.stickerType === StickerType.POSTER && (
                <Poster shapeId={sticker.shape} color={sticker.color} size={'big'} text={sticker.text} />
            )}
        </>
    );
};

export default StickerItemPreview;
